module.exports = __webpack_public_path__ + "img/loginVector.fe1765dc.png";